export function parseJson<T>(text: string | null | undefined): T | undefined {
  if (!text) return undefined
  try {
    return JSON.parse(text)
  } catch (e) {
    return undefined
  }
}
